


























import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseImage from "@/components/BaseImage/BaseImage";

export default defineComponent({
  name: "PersonalIdExampleConfirm",
  components: { BaseImage, BaseConfirm, BaseButton },
  props: {
    value: { type: Boolean, default: false },
  },
});
